import { MicrofrontendEvent } from '@descomplica/microfrontend-core';

export class SelectClassifierEvent extends MicrofrontendEvent {}
